// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Utility-first CSS classes for layout, spacing, and responsiveness */
/* These utilities are designed specfically for the profile pane */
/* Utilities that can be shared by all panes should be added to dev-globals.css 
   and to mashlib repo mash-utilities.css and then updated accross all pane
   development environments */
:root {
  --profile-image-size: 3em;
}

.profile-pane-host {
  display: block;
  width: 100%;
  min-width: 100%;
  max-width: none;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .profile-grid {
    font-size: clamp(0.9rem, 1.1vw + 0.65rem, 1rem);
  }

  .profile-grid .profile__action-button,
  .profile-grid .profile__actions button {
    min-height: calc(var(--min-touch-target, 44px) + 0.5em) !important;
    font-size: clamp(0.9rem, 2.1vw, 1rem) !important;
    padding: 0.75em 0.9em !important;
  }
}

/* ===========================================
   PROFILE GRID LAYOUT
   =========================================== */

.profile-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: var(--spacing-xxs, 0.3125rem);
  background: var(--color-background, #F8F9FB);
}

.profile-grid > * {
  min-width: 0;
}

.profile-pane-root {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: block;
  container-name: profile-pane;
  container-type: inline-size;
}

/* Embedded rendering inside SolidOS outline table cells needs a single-column fallback.
   The outline reserves space for icon/predicate columns, so the available content width
   is effectively much narrower than the viewport. */
td.obj .profile-pane-root {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

@container profile-pane (max-width: 768px) {
  .profile-grid {
    font-size: clamp(0.9rem, 1.1vw + 0.65rem, 1rem);
  }

  .profile-grid .profile__action-button,
  .profile-grid .profile__actions button {
    min-height: calc(var(--min-touch-target, 44px) + 0.5em) !important;
    font-size: clamp(0.9rem, 2.1vw, 1rem) !important;
    padding: 0.75em 0.9em !important;
  }
}

@container profile-pane (max-width: 768px) {
  .profile-grid {
    grid-template-columns: 1fr;
    gap: var(--spacing-xxs, 0.3125rem);
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    padding-inline: var(--spacing-xxs, 0.3125rem);
    overflow-x: clip;
  }
}

@media (max-width: 768px) {
  .profile-grid {
    grid-template-columns: 1fr;
    gap: var(--spacing-xxs, 0.3125rem);
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    padding-inline: var(--spacing-xxs, 0.3125rem);
    overflow-x: clip;
  }
}

/* END GRID LAYOUT */

.profile__section {
  width: 100%;
}

.profile__section--empty {
  padding: var(--spacing-1xl, 2.5rem) var(--spacing-lg, 1.5625rem); /* 40px 25px */
  width: 100%;
}

.profile__section,
.profile__section--empty,
.profile__action-button--empty {
  background: var(--color-card-bg, #fff);
}

/* Header row layout utility for profile section headers */
.profile__section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-xs, 0.75rem);
  width: 100%;
}

.profile__section-header h2,
.profile__section-header h3,
.profile__section-header h4 {
  margin: 0;
}

.profile__action-button {
  width: 100%;
  min-width: 11.25rem; /* 180px */
  max-width: 20rem; /* 320px */
  box-sizing: border-box;
  display: inline-block;
}

.profile__action-button--empty {
  /*padding: 6px 8px; Note: these are the styles from new design
  min-height: auto;   however they don't meet accessibility guidelines 
  min-width: 0;       for touch target size */ 
  width: fit-content;
  min-width: fit-content;
  max-width: fit-content;
  white-space: nowrap;
  box-sizing: border-box;
  border: var(--border-width-sm, 1px) solid var(--color-border-darker, #4A5565);
  color: var(--slate-700, #314158);
  font-size: var(--font-size-sm, 0.875rem); /* 14px */
  font-weight: var(--font-weight-medium, 500);
  line-height: var(--line-height-tight, 1.4);
}
.profile__empty-state-message {
  color: #62748E;
  text-align: center;
  font-size: var(--font-size-xs, 0.813rem); /* 13px */
  font-weight: var(--font-weight-normal, 400);
  line-height: var(--line-height-tight, 1.4); /* 140% from design 18.2px */
}
.contact-info__icon-wrapper {
  width: 36px;
  height: 36px;
  padding: 0 0.575rem; /* 9.2px - from design, but also ensures icons are centered in the circle */
  flex-shrink: 0;
}

.contact-info__icon {
  width: var(--icon-xxs, 1rem); /* 16px */
  height: var(--icon-xxs, 1rem); /* 16px */
  flex-shrink: 0;
  stroke-width: 1.333px;
  stroke: #90A1B9;
}

.contact-info__contact-point-value {
  color: var(--slate-800, #1D293D);
  font-size: var(--font-size-sm, 0.875rem); /* 14px */
  font-weight: var(--font-weight-bold, 600);
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.contact-info__contact-point-type {
  color: var(--slate-500, #62748E);
  font-size: var(--font-size-xxs, 0.75rem); /* 12px */
  font-weight: var(--font-weight-md, 500);
}

.contact-info__address {
  color: var(--slate-800, #1D293D);
  font-size: var(--font-size-sm, 0.875rem); /* 14px */
  font-weight: var(--font-weight-bold, 600);
}

.contact-info__list {
  list-style: none;
  margin: 0;
  padding: 0 0 var(--spacing-2xs, 0.625rem) 0;
  gap: var(--spacing-2xs, 0.625rem);
}

.contact-info__list:last-of-type {
  padding-bottom: 0;
}

.contact-info__list + .contact-info__list {
  margin-top: var(--spacing-2xs, 0.625rem);
}

.contact-info__item {
  margin-inline-start: 0;
}

.contact-info__empty-icon svg {
  width: var(--icon-md, 2.5rem); /* 40px */
  height: var(--icon-md, 2.5rem); /* 40px */
  display: block;
}

.contact-info__empty-icon svg path {
  stroke-width: 0.25rem; /* 4px */
  stroke: #E5E7EB;
}

.contact-info__empty-message {
  color: #9CA3AF;
  text-align: center;
  font-size: var(--font-size-xs, 0.813rem); /* 13px */
  font-weight: var(--font-weight-normal, 400);
  line-height: var(--line-height-tight, 1.4); /* design says 1.2 */
}

.contact-info__empty-icon-wrapper {
  width: 3rem; /* 48px */
  flex: 1 0 0;
}
.profile__empty-state-content {
  gap: var(--spacing-2xs, 0.625rem); /* 10px */
}

.profile__empty-state-content > h2,
.profile__empty-state-content > p {
  margin: 0;
}

/* SAM - generated by ai below need to check design and change */
.profile__action-button--empty:hover {
  background: var(--color-primary, #7C4DFF);
  border-color: var(--color-primary, #7C4DFF);
  color: white;
}

.profile__add-more-content {
  gap: var(--spacing-xxs, 0.3125rem);
}

.profile__add-more-icon {
  width: var(--icon-xxxs, 0.75rem); /* 12px */
  height: var(--icon-xxxs, 0.75rem); /* 12px */
  line-height: 0;
  flex: 0 0 auto;
}

.profile__add-more-icon svg {
  width: 100%;
  height: 100%;
  display: block;
}

.skills__list {
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: flex-start;
  gap: 0.5rem; /* 8px */
}

.skills__item {
  gap: 0.2rem;
}

.skills__item-label {
  color: var(--slate-900, #0F172B);
  font-size: var(--font-size-sm, 0.875rem); /* 14px */
  font-weight: var(--font-weight-md, 500);
  line-height: 1.2;
}

.skills__remove-button {
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  line-height: 1;
}

.languages__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.languages__item-label {
  color: var(--gray-900, #101828);
  font-size: var(--font-size-md, 1rem); /* 16px */
  font-weight: var(--font-weight-md, 500);
}

.languages__empty-icon {
  width: var(--icon-xs, 1.5rem); /* 24px new design uses this */
  height: var(--icon-xs, 1.5rem); /* 24px new design uses this */
  flex-shrink: 0;
}
/* Add-me-to-friends button style shared across profile sections. */
.profile__btn-friends {
  width: auto;
  min-width: 0;
  max-width: none;
  padding: 0.375rem 0.75rem;
  gap: var(--spacing-xxs, 0.3125rem);
  border-radius: var(--border-radius-md, 0.5rem);
  border: 1px solid var(--color-primary, #7C4DFF);
  background: transparent;
  color: var(--color-primary, #7C4DFF);
}

/* Text-style action button utility (used for section header/edit actions). */
.profile-action-text {
  width: auto;
  min-width: 0;
  max-width: none;
  padding: var(--spacing-xxs, 0.3125rem);
  border: none;
  background: none;
  color: var(--color-primary, #7C4DFF);
  cursor: pointer;
  font-size: var(--font-size-sm, 0.875rem);
}

.profile-action-text:hover {
  text-decoration: underline;
}

.profile-section-collapsible {
  display: block;
}

.profile-section-collapsible__header {
  margin-bottom: 0;
}

.profile-section-collapsible__actions {
  gap: var(--spacing-xs, 0.75rem);
  margin-top: -0.25rem;
}

.profile-section-collapsible__edit-button {
  min-width: 0;
}

.profile-section-collapsible__edit-icon {
  display: none;
}

.profile-section-collapsible__actions > button.inline-flex-row {
  display: none !important;
  min-height: auto;
  min-width: auto;
  padding: var(--spacing-xxs, 0.3125rem);
  border: none;
  background: none;
  color: var(--color-text, #1A1A1A);
  cursor: pointer;
}

.profile-section-collapsible__chevron {
  display: inline-block;
  flex: 0 0 auto;
  transition: transform var(--animation-duration, 0.2s) ease;
}

.profile-section-collapsible__content {
  margin-top: var(--spacing-2xs, 0.625rem);
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.profile-section-collapsible__content > :first-child {
  margin-top: 0;
}

.profile-section-collapsible__content > :last-child {
  margin-bottom: 0;
}

.bioCard,
.bioSection,
.socialCard,
.socialList,
.skills__list,
.languages__list,
.contact-info__list {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

@media (min-width: 769px) {
  .profile-section-collapsible > .profile-section-collapsible__content {
    display: block;
  }

  .profile-section-collapsible__edit-label svg,
  .profile__action-icon svg {
    width: 0.875rem;
    height: 0.875rem;
  }

  .profile-section-collapsible__edit-label svg path,
  .profile__action-icon svg path {
    fill: var(--color-primary, #7C4DFF);
  }

  .profile-section-collapsible__edit-label {
    display: inline;
    transform: translateY(-0.125rem);
  }

  .profile__add-more-icon {
    transform: translateY(-0.125rem);
  }

  .profile-section-collapsible__edit-icon {
    display: none;
  }
}

@media (max-width: 576px) {
  .profile-grid .profile__section-header h2,
  .profile-grid .profile__section-header h3,
  .profile-grid .profile__section-header h4,
  .profile-grid .profile__empty-state-content > h2,
  .profile-grid .cvSection h3,
  .profile-grid .profile__name,
  .profile-grid .friends-pane__header-name {
    font-family: inherit !important;
  }

  .profile-section-collapsible--inline-mobile-actions > .profile-section-collapsible__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
  }

  .profile-section-collapsible--inline-mobile-actions > .profile-section-collapsible__header h2 {
    margin: 0;
    flex: 1 1 auto;
    min-width: 0;
  }

  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__actions {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
    margin-top: 0;
    flex: 0 0 auto;
  }

  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button {
    display: inline-flex !important;
    order: 1;
  }

  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button:active,
  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button:focus,
  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button:focus-visible {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__actions > button.inline-flex-row {
    order: 2;
  }

  .profile__section-header h2,
  .profile__section-header h3,
  .profile__section-header h4 {
    font-size: var(--font-size-lg, 1.125rem) !important;
    line-height: 1.2 !important;
  }

  .profile-grid .profile__empty-state-content > h2,
  .profile-grid .cvSection h3 {
    font-size: var(--font-size-lg, 1.125rem) !important;
    line-height: 1.2 !important;
  }

  .profile-grid .profile__name,
  .profile-grid .friends-pane__header-name {
    font-size: 1.5rem !important;
    line-height: 1.15 !important;
  }

  .profile-grid .profile__pronouns,
  .profile-grid .friends-pane__header-pronouns,
  .profile-grid .friends-pane__friends-pronouns {
    font-family: inherit !important;
    font-size: 0.6875rem !important;
    line-height: 1.1 !important;
  }

  .profile-section-collapsible[data-expanded="false"] .profile-section-collapsible__content {
    display: none;
  }

  .profile-section-collapsible__actions.flex-column {
    align-items: flex-end;
    gap: 0.25rem;
  }

  /* Keep empty-section mobile header controls in the same order as regular sections: toggle first, add/edit below. */
  .profile__section--empty .profile-section-collapsible__actions > button.inline-flex-row {
    order: 1;
  }

  .profile__section--empty .profile-section-collapsible__actions > .profile-section-collapsible__edit-button {
    order: 2;
  }

  .profile-section-collapsible[data-expanded="true"] .profile-section-collapsible__chevron {
    transform: rotate(180deg);
  }

  .profile-section-collapsible__edit-label {
    display: none !important;
  }

  .profile-section-collapsible__edit-icon {
    display: inline;
  }

  /* Empty-state action buttons use icon-only mobile controls (plus sign). */
  .profile__section--empty .profile-section-collapsible__edit-label {
    display: none !important;
  }

  .profile__section--empty .profile-section-collapsible__edit-icon {
    display: inline !important;
  }

  .profile-section-collapsible .profile-section-collapsible__edit-button {
    display: none !important;
    order: 2;
  }

  .profile-section-collapsible[data-expanded="true"] .profile-section-collapsible__edit-button {
    display: inline-flex !important;
  }
  /* Reassert toggle button layout in collapsible action rows on mobile 
  so utility resets never hide/misalign the control. */
  .profile-section-collapsible__actions > button.inline-flex-row {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
  }

  .profile-section-collapsible__edit-icon--add svg path {
    fill: #1E2939 !important;
    stroke: #1E2939 !important;
  }

  .profile-section-collapsible__edit-icon--projects svg path {
    stroke-width: 1.714px !important;
    stroke: var(--gray-800, #1E2939) !important;
    fill: none !important;
  }

}

@container profile-pane (max-width: 576px) {
  .profile-grid .profile__section-header h2,
  .profile-grid .profile__section-header h3,
  .profile-grid .profile__section-header h4,
  .profile-grid .profile__empty-state-content > h2,
  .profile-grid .cvSection h3,
  .profile-grid .profile__name,
  .profile-grid .friends-pane__header-name {
    font-family: inherit !important;
  }

  .profile-section-collapsible--inline-mobile-actions > .profile-section-collapsible__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
  }

  .profile-section-collapsible--inline-mobile-actions > .profile-section-collapsible__header h2 {
    margin: 0;
    flex: 1 1 auto;
    min-width: 0;
  }

  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__actions {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
    margin-top: 0;
    flex: 0 0 auto;
  }

  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button {
    order: 1;
  }

  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button:active,
  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button:focus,
  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button:focus-visible {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__actions > button.inline-flex-row {
    order: 2;
  }

  .profile__section-header h2,
  .profile__section-header h3,
  .profile__section-header h4 {
    font-size: var(--font-size-lg, 1.125rem) !important;
    line-height: 1.2 !important;
  }

  .profile-grid .profile__empty-state-content > h2,
  .profile-grid .cvSection h3 {
    font-size: var(--font-size-lg, 1.125rem) !important;
    line-height: 1.2 !important;
  }

  .profile-grid .profile__name,
  .profile-grid .friends-pane__header-name {
    font-size: 1.5rem !important;
    line-height: 1.15 !important;
  }

  .profile-grid .profile__pronouns,
  .profile-grid .friends-pane__header-pronouns,
  .profile-grid .friends-pane__friends-pronouns {
    font-family: inherit !important;
    font-size: 0.6875rem !important;
    line-height: 1.1 !important;
  }

  .profile-section-collapsible[data-expanded="false"] .profile-section-collapsible__content {
    display: none;
  }

  .profile-section-collapsible__actions.flex-column {
    align-items: flex-end;
    gap: 0.25rem;
  }

  .profile__section--empty .profile-section-collapsible__actions > button.inline-flex-row {
    order: 1;
  }

  .profile__section--empty .profile-section-collapsible__actions > .profile-section-collapsible__edit-button {
    order: 2;
  }

  .profile-section-collapsible[data-expanded="true"] .profile-section-collapsible__chevron {
    transform: rotate(180deg);
  }

  .profile-section-collapsible__edit-label {
    display: none !important;
  }

  .profile-section-collapsible__edit-icon {
    display: inline;
  }

  .profile__section--empty .profile-section-collapsible__edit-label {
    display: none !important;
  }

  .profile__section--empty .profile-section-collapsible__edit-icon {
    display: inline !important;
  }

  .profile-section-collapsible .profile-section-collapsible__edit-button {
    display: none !important;
    order: 2;
  }

  .profile-section-collapsible[data-expanded="true"] .profile-section-collapsible__edit-button {
    display: inline-flex !important;
  }

  .profile-section-collapsible__actions > button.inline-flex-row {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
  }

  .profile-section-collapsible__edit-icon--add svg path {
    fill: #1E2939 !important;
    stroke: #1E2939 !important;
  }

  .profile-section-collapsible__edit-icon--projects svg path {
    stroke-width: 1.714px !important;
    stroke: var(--gray-800, #1E2939) !important;
    fill: none !important;
  }
}

/* Zebra Striping - used by FriendList, StuffCard tables */
.zebra-stripe tr:nth-child(even),
.zebra-stripe > *:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.02);
}

`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/utilities.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE,kEAAkE;AAClE;;6BAE6B;AAC7B;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE;IACE,+CAA+C;EACjD;;EAEA;;IAEE,kEAAkE;IAClE,gDAAgD;IAChD,gCAAgC;EAClC;AACF;;AAEA;;gDAEgD;;AAEhD;EACE,aAAa;EACb,oDAAoD;EACpD,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;oDAEoD;AACpD;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,+CAA+C;EACjD;;EAEA;;IAEE,kEAAkE;IAClE,gDAAgD;IAChD,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,kCAAkC;IAClC,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,6CAA6C;IAC7C,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,kCAAkC;IAClC,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,6CAA6C;IAC7C,gBAAgB;EAClB;AACF;;AAEA,oBAAoB;;AAEpB;EACE,WAAW;AACb;;AAEA;EACE,gEAAgE,EAAE,cAAc;EAChF,WAAW;AACb;;AAEA;;;EAGE,sCAAsC;AACxC;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;;;EAGE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB,EAAE,UAAU;EAC/B,gBAAgB,EAAE,UAAU;EAC5B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE;;6CAE2C;EAC3C,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,6EAA6E;EAC7E,gCAAgC;EAChC,wCAAwC,EAAE,SAAS;EACnD,2CAA2C;EAC3C,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,wCAAwC,EAAE,SAAS;EACnD,2CAA2C;EAC3C,0CAA0C,EAAE,4BAA4B;AAC1E;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE,2EAA2E;EAChG,cAAc;AAChB;;AAEA;EACE,4BAA4B,EAAE,SAAS;EACvC,6BAA6B,EAAE,SAAS;EACxC,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC,EAAE,SAAS;EACnD,yCAAyC;EACzC,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC,EAAE,SAAS;EACnD,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;EAChC,wCAAwC,EAAE,SAAS;EACnD,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B,EAAE,SAAS;EACxC,8BAA8B,EAAE,SAAS;EACzC,cAAc;AAChB;;AAEA;EACE,qBAAqB,EAAE,QAAQ;EAC/B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wCAAwC,EAAE,SAAS;EACnD,2CAA2C;EAC3C,0CAA0C,EAAE,oBAAoB;AAClE;;AAEA;EACE,WAAW,EAAE,SAAS;EACtB,WAAW;AACb;AACA;EACE,iCAAiC,EAAE,SAAS;AAC9C;;AAEA;;EAEE,SAAS;AACX;;AAEA,gEAAgE;AAChE;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC,EAAE,SAAS;EAC3C,iCAAiC,EAAE,SAAS;EAC5C,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,WAAW,EAAE,QAAQ;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,wCAAwC,EAAE,SAAS;EACnD,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC,EAAE,SAAS;EAC/C,uCAAuC;AACzC;;AAEA;EACE,6BAA6B,EAAE,8BAA8B;EAC7D,8BAA8B,EAAE,8BAA8B;EAC9D,cAAc;AAChB;AACA,mEAAmE;AACnE;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kCAAkC;EAClC,8CAA8C;EAC9C,+CAA+C;EAC/C,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA,6EAA6E;AAC7E;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;;;;;;IAOE,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,+BAA+B;IAC/B,QAAQ;EACV;;EAEA;;;IAGE,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,QAAQ;EACV;;EAEA;;;IAGE,mDAAmD;IACnD,2BAA2B;EAC7B;;EAEA;;IAEE,mDAAmD;IACnD,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;;;IAGE,+BAA+B;IAC/B,+BAA+B;IAC/B,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA,mHAAmH;EACnH;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA,0EAA0E;EAC1E;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,QAAQ;EACV;;EAEA;IACE,+BAA+B;EACjC;EACA;sDACoD;EACpD;IACE,+BAA+B;IAC/B,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;IAChC,2CAA2C;IAC3C,qBAAqB;EACvB;;AAEF;;AAEA;EACE;;;;;;;IAOE,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,SAAS;IACT,cAAc;IACd,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;;;IAGE,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,QAAQ;EACV;;EAEA;;;IAGE,mDAAmD;IACnD,2BAA2B;EAC7B;;EAEA;;IAEE,mDAAmD;IACnD,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;;;IAGE,+BAA+B;IAC/B,+BAA+B;IAC/B,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,QAAQ;EACV;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;IAC/B,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;IAChC,2CAA2C;IAC3C,qBAAqB;EACvB;AACF;;AAEA,0DAA0D;AAC1D;;EAEE,qCAAqC;AACvC","sourcesContent":["/* Utility-first CSS classes for layout, spacing, and responsiveness */\n/* These utilities are designed specfically for the profile pane */\n/* Utilities that can be shared by all panes should be added to dev-globals.css \n   and to mashlib repo mash-utilities.css and then updated accross all pane\n   development environments */\n:root {\n  --profile-image-size: 3em;\n}\n\n.profile-pane-host {\n  display: block;\n  width: 100%;\n  min-width: 100%;\n  max-width: none;\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .profile-grid {\n    font-size: clamp(0.9rem, 1.1vw + 0.65rem, 1rem);\n  }\n\n  .profile-grid .profile__action-button,\n  .profile-grid .profile__actions button {\n    min-height: calc(var(--min-touch-target, 44px) + 0.5em) !important;\n    font-size: clamp(0.9rem, 2.1vw, 1rem) !important;\n    padding: 0.75em 0.9em !important;\n  }\n}\n\n/* ===========================================\n   PROFILE GRID LAYOUT\n   =========================================== */\n\n.profile-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);\n  gap: var(--spacing-xxs, 0.3125rem);\n  background: var(--color-background, #F8F9FB);\n}\n\n.profile-grid > * {\n  min-width: 0;\n}\n\n.profile-pane-root {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  display: block;\n  container-name: profile-pane;\n  container-type: inline-size;\n}\n\n/* Embedded rendering inside SolidOS outline table cells needs a single-column fallback.\n   The outline reserves space for icon/predicate columns, so the available content width\n   is effectively much narrower than the viewport. */\ntd.obj .profile-pane-root {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n@container profile-pane (max-width: 768px) {\n  .profile-grid {\n    font-size: clamp(0.9rem, 1.1vw + 0.65rem, 1rem);\n  }\n\n  .profile-grid .profile__action-button,\n  .profile-grid .profile__actions button {\n    min-height: calc(var(--min-touch-target, 44px) + 0.5em) !important;\n    font-size: clamp(0.9rem, 2.1vw, 1rem) !important;\n    padding: 0.75em 0.9em !important;\n  }\n}\n\n@container profile-pane (max-width: 768px) {\n  .profile-grid {\n    grid-template-columns: 1fr;\n    gap: var(--spacing-xxs, 0.3125rem);\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n    margin: 0 auto;\n    padding-inline: var(--spacing-xxs, 0.3125rem);\n    overflow-x: clip;\n  }\n}\n\n@media (max-width: 768px) {\n  .profile-grid {\n    grid-template-columns: 1fr;\n    gap: var(--spacing-xxs, 0.3125rem);\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n    margin: 0 auto;\n    padding-inline: var(--spacing-xxs, 0.3125rem);\n    overflow-x: clip;\n  }\n}\n\n/* END GRID LAYOUT */\n\n.profile__section {\n  width: 100%;\n}\n\n.profile__section--empty {\n  padding: var(--spacing-1xl, 2.5rem) var(--spacing-lg, 1.5625rem); /* 40px 25px */\n  width: 100%;\n}\n\n.profile__section,\n.profile__section--empty,\n.profile__action-button--empty {\n  background: var(--color-card-bg, #fff);\n}\n\n/* Header row layout utility for profile section headers */\n.profile__section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-xs, 0.75rem);\n  width: 100%;\n}\n\n.profile__section-header h2,\n.profile__section-header h3,\n.profile__section-header h4 {\n  margin: 0;\n}\n\n.profile__action-button {\n  width: 100%;\n  min-width: 11.25rem; /* 180px */\n  max-width: 20rem; /* 320px */\n  box-sizing: border-box;\n  display: inline-block;\n}\n\n.profile__action-button--empty {\n  /*padding: 6px 8px; Note: these are the styles from new design\n  min-height: auto;   however they don't meet accessibility guidelines \n  min-width: 0;       for touch target size */ \n  width: fit-content;\n  min-width: fit-content;\n  max-width: fit-content;\n  white-space: nowrap;\n  box-sizing: border-box;\n  border: var(--border-width-sm, 1px) solid var(--color-border-darker, #4A5565);\n  color: var(--slate-700, #314158);\n  font-size: var(--font-size-sm, 0.875rem); /* 14px */\n  font-weight: var(--font-weight-medium, 500);\n  line-height: var(--line-height-tight, 1.4);\n}\n.profile__empty-state-message {\n  color: #62748E;\n  text-align: center;\n  font-size: var(--font-size-xs, 0.813rem); /* 13px */\n  font-weight: var(--font-weight-normal, 400);\n  line-height: var(--line-height-tight, 1.4); /* 140% from design 18.2px */\n}\n.contact-info__icon-wrapper {\n  width: 36px;\n  height: 36px;\n  padding: 0 0.575rem; /* 9.2px - from design, but also ensures icons are centered in the circle */\n  flex-shrink: 0;\n}\n\n.contact-info__icon {\n  width: var(--icon-xxs, 1rem); /* 16px */\n  height: var(--icon-xxs, 1rem); /* 16px */\n  flex-shrink: 0;\n  stroke-width: 1.333px;\n  stroke: #90A1B9;\n}\n\n.contact-info__contact-point-value {\n  color: var(--slate-800, #1D293D);\n  font-size: var(--font-size-sm, 0.875rem); /* 14px */\n  font-weight: var(--font-weight-bold, 600);\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.contact-info__contact-point-type {\n  color: var(--slate-500, #62748E);\n  font-size: var(--font-size-xxs, 0.75rem); /* 12px */\n  font-weight: var(--font-weight-md, 500);\n}\n\n.contact-info__address {\n  color: var(--slate-800, #1D293D);\n  font-size: var(--font-size-sm, 0.875rem); /* 14px */\n  font-weight: var(--font-weight-bold, 600);\n}\n\n.contact-info__list {\n  list-style: none;\n  margin: 0;\n  padding: 0 0 var(--spacing-2xs, 0.625rem) 0;\n  gap: var(--spacing-2xs, 0.625rem);\n}\n\n.contact-info__list:last-of-type {\n  padding-bottom: 0;\n}\n\n.contact-info__list + .contact-info__list {\n  margin-top: var(--spacing-2xs, 0.625rem);\n}\n\n.contact-info__item {\n  margin-inline-start: 0;\n}\n\n.contact-info__empty-icon svg {\n  width: var(--icon-md, 2.5rem); /* 40px */\n  height: var(--icon-md, 2.5rem); /* 40px */\n  display: block;\n}\n\n.contact-info__empty-icon svg path {\n  stroke-width: 0.25rem; /* 4px */\n  stroke: #E5E7EB;\n}\n\n.contact-info__empty-message {\n  color: #9CA3AF;\n  text-align: center;\n  font-size: var(--font-size-xs, 0.813rem); /* 13px */\n  font-weight: var(--font-weight-normal, 400);\n  line-height: var(--line-height-tight, 1.4); /* design says 1.2 */\n}\n\n.contact-info__empty-icon-wrapper {\n  width: 3rem; /* 48px */\n  flex: 1 0 0;\n}\n.profile__empty-state-content {\n  gap: var(--spacing-2xs, 0.625rem); /* 10px */\n}\n\n.profile__empty-state-content > h2,\n.profile__empty-state-content > p {\n  margin: 0;\n}\n\n/* SAM - generated by ai below need to check design and change */\n.profile__action-button--empty:hover {\n  background: var(--color-primary, #7C4DFF);\n  border-color: var(--color-primary, #7C4DFF);\n  color: white;\n}\n\n.profile__add-more-content {\n  gap: var(--spacing-xxs, 0.3125rem);\n}\n\n.profile__add-more-icon {\n  width: var(--icon-xxxs, 0.75rem); /* 12px */\n  height: var(--icon-xxxs, 0.75rem); /* 12px */\n  line-height: 0;\n  flex: 0 0 auto;\n}\n\n.profile__add-more-icon svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.skills__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  align-items: flex-start;\n  gap: 0.5rem; /* 8px */\n}\n\n.skills__item {\n  gap: 0.2rem;\n}\n\n.skills__item-label {\n  color: var(--slate-900, #0F172B);\n  font-size: var(--font-size-sm, 0.875rem); /* 14px */\n  font-weight: var(--font-weight-md, 500);\n  line-height: 1.2;\n}\n\n.skills__remove-button {\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  line-height: 1;\n}\n\n.languages__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.languages__item-label {\n  color: var(--gray-900, #101828);\n  font-size: var(--font-size-md, 1rem); /* 16px */\n  font-weight: var(--font-weight-md, 500);\n}\n\n.languages__empty-icon {\n  width: var(--icon-xs, 1.5rem); /* 24px new design uses this */\n  height: var(--icon-xs, 1.5rem); /* 24px new design uses this */\n  flex-shrink: 0;\n}\n/* Add-me-to-friends button style shared across profile sections. */\n.profile__btn-friends {\n  width: auto;\n  min-width: 0;\n  max-width: none;\n  padding: 0.375rem 0.75rem;\n  gap: var(--spacing-xxs, 0.3125rem);\n  border-radius: var(--border-radius-md, 0.5rem);\n  border: 1px solid var(--color-primary, #7C4DFF);\n  background: transparent;\n  color: var(--color-primary, #7C4DFF);\n}\n\n/* Text-style action button utility (used for section header/edit actions). */\n.profile-action-text {\n  width: auto;\n  min-width: 0;\n  max-width: none;\n  padding: var(--spacing-xxs, 0.3125rem);\n  border: none;\n  background: none;\n  color: var(--color-primary, #7C4DFF);\n  cursor: pointer;\n  font-size: var(--font-size-sm, 0.875rem);\n}\n\n.profile-action-text:hover {\n  text-decoration: underline;\n}\n\n.profile-section-collapsible {\n  display: block;\n}\n\n.profile-section-collapsible__header {\n  margin-bottom: 0;\n}\n\n.profile-section-collapsible__actions {\n  gap: var(--spacing-xs, 0.75rem);\n  margin-top: -0.25rem;\n}\n\n.profile-section-collapsible__edit-button {\n  min-width: 0;\n}\n\n.profile-section-collapsible__edit-icon {\n  display: none;\n}\n\n.profile-section-collapsible__actions > button.inline-flex-row {\n  display: none !important;\n  min-height: auto;\n  min-width: auto;\n  padding: var(--spacing-xxs, 0.3125rem);\n  border: none;\n  background: none;\n  color: var(--color-text, #1A1A1A);\n  cursor: pointer;\n}\n\n.profile-section-collapsible__chevron {\n  display: inline-block;\n  flex: 0 0 auto;\n  transition: transform var(--animation-duration, 0.2s) ease;\n}\n\n.profile-section-collapsible__content {\n  margin-top: var(--spacing-2xs, 0.625rem);\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.profile-section-collapsible__content > :first-child {\n  margin-top: 0;\n}\n\n.profile-section-collapsible__content > :last-child {\n  margin-bottom: 0;\n}\n\n.bioCard,\n.bioSection,\n.socialCard,\n.socialList,\n.skills__list,\n.languages__list,\n.contact-info__list {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n@media (min-width: 769px) {\n  .profile-section-collapsible > .profile-section-collapsible__content {\n    display: block;\n  }\n\n  .profile-section-collapsible__edit-label svg,\n  .profile__action-icon svg {\n    width: 0.875rem;\n    height: 0.875rem;\n  }\n\n  .profile-section-collapsible__edit-label svg path,\n  .profile__action-icon svg path {\n    fill: var(--color-primary, #7C4DFF);\n  }\n\n  .profile-section-collapsible__edit-label {\n    display: inline;\n    transform: translateY(-0.125rem);\n  }\n\n  .profile__add-more-icon {\n    transform: translateY(-0.125rem);\n  }\n\n  .profile-section-collapsible__edit-icon {\n    display: none;\n  }\n}\n\n@media (max-width: 576px) {\n  .profile-grid .profile__section-header h2,\n  .profile-grid .profile__section-header h3,\n  .profile-grid .profile__section-header h4,\n  .profile-grid .profile__empty-state-content > h2,\n  .profile-grid .cvSection h3,\n  .profile-grid .profile__name,\n  .profile-grid .friends-pane__header-name {\n    font-family: inherit !important;\n  }\n\n  .profile-section-collapsible--inline-mobile-actions > .profile-section-collapsible__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n  }\n\n  .profile-section-collapsible--inline-mobile-actions > .profile-section-collapsible__header h2 {\n    margin: 0;\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__actions {\n    display: inline-flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.25rem;\n    margin-top: 0;\n    flex: 0 0 auto;\n  }\n\n  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button {\n    display: inline-flex !important;\n    order: 1;\n  }\n\n  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button:active,\n  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button:focus,\n  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button:focus-visible {\n    border: none !important;\n    outline: none !important;\n    box-shadow: none !important;\n    background: transparent !important;\n  }\n\n  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__actions > button.inline-flex-row {\n    order: 2;\n  }\n\n  .profile__section-header h2,\n  .profile__section-header h3,\n  .profile__section-header h4 {\n    font-size: var(--font-size-lg, 1.125rem) !important;\n    line-height: 1.2 !important;\n  }\n\n  .profile-grid .profile__empty-state-content > h2,\n  .profile-grid .cvSection h3 {\n    font-size: var(--font-size-lg, 1.125rem) !important;\n    line-height: 1.2 !important;\n  }\n\n  .profile-grid .profile__name,\n  .profile-grid .friends-pane__header-name {\n    font-size: 1.5rem !important;\n    line-height: 1.15 !important;\n  }\n\n  .profile-grid .profile__pronouns,\n  .profile-grid .friends-pane__header-pronouns,\n  .profile-grid .friends-pane__friends-pronouns {\n    font-family: inherit !important;\n    font-size: 0.6875rem !important;\n    line-height: 1.1 !important;\n  }\n\n  .profile-section-collapsible[data-expanded=\"false\"] .profile-section-collapsible__content {\n    display: none;\n  }\n\n  .profile-section-collapsible__actions.flex-column {\n    align-items: flex-end;\n    gap: 0.25rem;\n  }\n\n  /* Keep empty-section mobile header controls in the same order as regular sections: toggle first, add/edit below. */\n  .profile__section--empty .profile-section-collapsible__actions > button.inline-flex-row {\n    order: 1;\n  }\n\n  .profile__section--empty .profile-section-collapsible__actions > .profile-section-collapsible__edit-button {\n    order: 2;\n  }\n\n  .profile-section-collapsible[data-expanded=\"true\"] .profile-section-collapsible__chevron {\n    transform: rotate(180deg);\n  }\n\n  .profile-section-collapsible__edit-label {\n    display: none !important;\n  }\n\n  .profile-section-collapsible__edit-icon {\n    display: inline;\n  }\n\n  /* Empty-state action buttons use icon-only mobile controls (plus sign). */\n  .profile__section--empty .profile-section-collapsible__edit-label {\n    display: none !important;\n  }\n\n  .profile__section--empty .profile-section-collapsible__edit-icon {\n    display: inline !important;\n  }\n\n  .profile-section-collapsible .profile-section-collapsible__edit-button {\n    display: none !important;\n    order: 2;\n  }\n\n  .profile-section-collapsible[data-expanded=\"true\"] .profile-section-collapsible__edit-button {\n    display: inline-flex !important;\n  }\n  /* Reassert toggle button layout in collapsible action rows on mobile \n  so utility resets never hide/misalign the control. */\n  .profile-section-collapsible__actions > button.inline-flex-row {\n    display: inline-flex !important;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .profile-section-collapsible__edit-icon--add svg path {\n    fill: #1E2939 !important;\n    stroke: #1E2939 !important;\n  }\n\n  .profile-section-collapsible__edit-icon--projects svg path {\n    stroke-width: 1.714px !important;\n    stroke: var(--gray-800, #1E2939) !important;\n    fill: none !important;\n  }\n\n}\n\n@container profile-pane (max-width: 576px) {\n  .profile-grid .profile__section-header h2,\n  .profile-grid .profile__section-header h3,\n  .profile-grid .profile__section-header h4,\n  .profile-grid .profile__empty-state-content > h2,\n  .profile-grid .cvSection h3,\n  .profile-grid .profile__name,\n  .profile-grid .friends-pane__header-name {\n    font-family: inherit !important;\n  }\n\n  .profile-section-collapsible--inline-mobile-actions > .profile-section-collapsible__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n  }\n\n  .profile-section-collapsible--inline-mobile-actions > .profile-section-collapsible__header h2 {\n    margin: 0;\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__actions {\n    display: inline-flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.25rem;\n    margin-top: 0;\n    flex: 0 0 auto;\n  }\n\n  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button {\n    order: 1;\n  }\n\n  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button:active,\n  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button:focus,\n  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__edit-button:focus-visible {\n    border: none !important;\n    outline: none !important;\n    box-shadow: none !important;\n    background: transparent !important;\n  }\n\n  .profile-section-collapsible--inline-mobile-actions .profile-section-collapsible__actions > button.inline-flex-row {\n    order: 2;\n  }\n\n  .profile__section-header h2,\n  .profile__section-header h3,\n  .profile__section-header h4 {\n    font-size: var(--font-size-lg, 1.125rem) !important;\n    line-height: 1.2 !important;\n  }\n\n  .profile-grid .profile__empty-state-content > h2,\n  .profile-grid .cvSection h3 {\n    font-size: var(--font-size-lg, 1.125rem) !important;\n    line-height: 1.2 !important;\n  }\n\n  .profile-grid .profile__name,\n  .profile-grid .friends-pane__header-name {\n    font-size: 1.5rem !important;\n    line-height: 1.15 !important;\n  }\n\n  .profile-grid .profile__pronouns,\n  .profile-grid .friends-pane__header-pronouns,\n  .profile-grid .friends-pane__friends-pronouns {\n    font-family: inherit !important;\n    font-size: 0.6875rem !important;\n    line-height: 1.1 !important;\n  }\n\n  .profile-section-collapsible[data-expanded=\"false\"] .profile-section-collapsible__content {\n    display: none;\n  }\n\n  .profile-section-collapsible__actions.flex-column {\n    align-items: flex-end;\n    gap: 0.25rem;\n  }\n\n  .profile__section--empty .profile-section-collapsible__actions > button.inline-flex-row {\n    order: 1;\n  }\n\n  .profile__section--empty .profile-section-collapsible__actions > .profile-section-collapsible__edit-button {\n    order: 2;\n  }\n\n  .profile-section-collapsible[data-expanded=\"true\"] .profile-section-collapsible__chevron {\n    transform: rotate(180deg);\n  }\n\n  .profile-section-collapsible__edit-label {\n    display: none !important;\n  }\n\n  .profile-section-collapsible__edit-icon {\n    display: inline;\n  }\n\n  .profile__section--empty .profile-section-collapsible__edit-label {\n    display: none !important;\n  }\n\n  .profile__section--empty .profile-section-collapsible__edit-icon {\n    display: inline !important;\n  }\n\n  .profile-section-collapsible .profile-section-collapsible__edit-button {\n    display: none !important;\n    order: 2;\n  }\n\n  .profile-section-collapsible[data-expanded=\"true\"] .profile-section-collapsible__edit-button {\n    display: inline-flex !important;\n  }\n\n  .profile-section-collapsible__actions > button.inline-flex-row {\n    display: inline-flex !important;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .profile-section-collapsible__edit-icon--add svg path {\n    fill: #1E2939 !important;\n    stroke: #1E2939 !important;\n  }\n\n  .profile-section-collapsible__edit-icon--projects svg path {\n    stroke-width: 1.714px !important;\n    stroke: var(--gray-800, #1E2939) !important;\n    fill: none !important;\n  }\n}\n\n/* Zebra Striping - used by FriendList, StuffCard tables */\n.zebra-stripe tr:nth-child(even),\n.zebra-stripe > *:nth-child(even) {\n  background-color: rgba(0, 0, 0, 0.02);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
